export default __webpack_public_path__ + "static/media/arrow.32c4c589.svg";